'use es6';

import { callWidgetDrilldown } from '../lib/salesAnalytics/drilldowns';
import { renderCell, renderDealActivity } from '../lib/salesAnalytics/renderUtils';
import { getBucketField, getBreakdownField, getMetricField } from '../lib/salesAnalytics/helpers';
import { getBreakdownColumns } from '../lib/salesAnalytics/tableColumns';
export const getTableColumns = (report, data, onDrilldown) => {
  const bucketField = getBucketField(report);
  const breakdownField = getBreakdownField(report);
  const metricField = getMetricField(report);
  const breakdownColumns = getBreakdownColumns(breakdownField, data);
  const renderTableCell = args => renderCell(args, `SUM|${metricField}`);
  const dealActivityColumn = breakdownField === 'dealstage' ? [{
    field: 'deal_activity',
    dataset: 'primary',
    renderCell: args => renderDealActivity(args),
    onClick: callWidgetDrilldown(report, onDrilldown)
  }] : [];
  const columns = breakdownColumns.size > 0 ? [{
    field: bucketField,
    dataset: 'primary'
  }, ...breakdownColumns.map(column => ({
    field: column,
    dataset: 'primary',
    renderCell: renderTableCell,
    onClick: callWidgetDrilldown(report, onDrilldown),
    align: 'right'
  })), ...dealActivityColumn, {
    field: 'Total',
    dataset: 'primary',
    renderCell: args => renderCell(Object.assign({}, args, {
      isFooter: true
    }), `SUM|${metricField}`)
  }] : [];
  return columns;
};